module.exports = __webpack_public_path__ + "img/ic_user_white.70f86222.svg";